module.exports = __webpack_public_path__ + "static/FAVT_banner.85a7c750.png";


//////////////////
// WEBPACK FOOTER
// ./src/templates/assets/FAVT_banner.png
// module id = 989
// module chunks = 101932004231744